import styled from 'styled-components'
import { black, blackOrange, textMuted } from '@/theme/colors'
import { text } from '@/theme/typography'

/** A section inside a page: Lato 700 22px. The page title itself is `PageHeading`. */
export const SectionHeading = styled.h2`
	${text.heading}
	color: ${blackOrange};
	margin: 0;
	text-wrap: balance;
`

/** A card's or modal's title: Lato 700 18px. */
export const CardTitle = styled.h3`
	${text.title}
	color: ${black};
	margin: 0;
`

/** Uppercase label above a group: Lato 700 12px, tracked. */
export const Eyebrow = styled.span`
	${text.eyebrow}
	color: ${textMuted};
`
